<template>
	<div class="rp-messenger-form-item">
		<label :for="`get-${property.name}`">
			<div
				class="rp-messenger-form-item__label"
			>{{ getTranslatedDisplayName('inputPropDisplayNames.'+property.name, property.displayName) }}{{property.required ? '*' : ''}}</div>
		</label>
		<VMargin :unit=".2" />
		<div class="input">
			<div v-if="showAllDataTypes" class="customer-journey-form-item">
				<div>
					<template v-if="property.type==='text' || property.type==='number'">
						<el-input
							:type="property.type"
							placeholder="Enter text"
							:id="`get-${property.name}`"
							size="large"
							v-model="property.vModelValue"
							@focus="handleFocus(property)"
							@input="handleFocus(property)"
							@keyup.enter.native.exact="submitOnEnter(property)"
							class="customer-journey-form__input"
							:class="{ 'error' : property.isError || isError }"
						>
							<el-button
								@click="handleClick(property)"
								type="primary"
								icon="el-icon-arrow-right"
								class="customer-journey-form__input-submit-btn"
								slot="append"
								v-if="showSubmit"
							/>
						</el-input>
					</template>

					<template v-if="property.type === 'yesOrNo'">
							<el-select
								class="customer-journey-form__input"
								:class="{ 'error' : property.isError || isError }"
								popper-class="customer-journey-form__select-input"
								v-model="property.vModelValue"
								size="large"
								placeholder="Select"
								:popper-append-to-body="false"
								@focus="handleFocus(property)"
								@change="handleClick(property)"
							>
								<el-option
									class="customer-journey-form__select-input-item"
									v-for="item in ['Yes', 'No']"
									:key="item"
									:label="item"
									:value="item"
								>
								<span class="customer-journey-form__select-input-item-name">{{ item }}</span>
								<span class="customer-journey-form__select-input-item-icon" v-if="property.vModelValue === item">
									<i class="el-icon-check"></i>
								</span>
								</el-option>
							</el-select>
					</template>
					<template v-if="property.type === 'boolean'">
							<el-select
								class="customer-journey-form__input"
								:class="{ 'error' : property.isError || isError }"
								popper-class="customer-journey-form__select-input"
								:popper-append-to-body="false"
								:value="getBooleanValueChange"
								size="large"
								placeholder="Select"
								@focus="handleFocus(property)"
								@change="setBooleanValueChange"
							>
								<el-option
									class="customer-journey-form__select-input-item"
									v-for="item in ['Yes', 'No']"
									:key="item"
									:label="item"
									:value="item"
								>
								<span class="customer-journey-form__select-input-item-name">{{ item }}</span>
								<span class="customer-journey-form__select-input-item-icon" v-if="property.vModelValue === item">
									<i class="el-icon-check"></i>
								</span>
								</el-option>
							</el-select>
					</template>

					<template v-if="property.type=='date'">
						<el-date-picker
							class="customer-journey-form__input"
							:class="{ 'error' : property.isError || isError }"
							v-model="property.vModelValue"
							type="date"
							placeholder="DD-MM-YYYY"
							:clearable="false"
							:format="'dd-MM-yyyy'"
							:value-format="'timestamp'"
							@focus="handleFocus(property)"
							@change="handleClick(property)"
							size="large"
							popper-class="rp-messenger-form-item__date-picker"
						></el-date-picker>
					</template>

					<template v-if="['dropdownSelect'].includes(property.type)">
						<el-select
							class="customer-journey-form__input"
							:class="{ 'error' : property.isError || isError }"
							popper-class="customer-journey-form__select-input"
							:popper-append-to-body="false"
							v-model="property.vModelValue"
							size="large"
							filterable
							placeholder="Select"
							@focus="handleFocus(property)"
							@change="handleClick(property)"
						>
							<el-option
								class="customer-journey-form__select-input-item"
								v-for="item in property.dropdownOption || ['Yes', 'No']"
								:key="item"
								:label="item"
								:value="item"
							>
								<span class="customer-journey-form__select-input-item-name">{{ item }}</span>
								<span class="customer-journey-form__select-input-item-icon" v-if="property.vModelValue === item">
									<i class="el-icon-check"></i>
								</span>
							</el-option>
						</el-select>
					</template>

					<template v-if="property.type === 'file'">
						<FileUpload  :filesList=[] @filesUploaded="updateFileList"/>
					</template>

					<template v-if="property.type=='multiline'">
						<el-input
							class="customer-journey-form__input"
							:class="{ 'error' : property.isError || isError }"
							type="textarea"
							:rows="3"
							maxlength="2000"
							:placeholder="property.placeholder === false ? '' : 'Enter text'"
							resize="none"
							v-model="property.vModelValue"
							@focus="handleFocus(property)"
							@input="handleFocus(property)"
							@keyup.enter.native.exact="submitOnEnter(property)"
						>
						</el-input>
						<template v-if="showSubmit">
							<VPadding :unit="0.4"/>
						 	<el-button @click="submitOnEnter(property)" class="form-item-multiselect-submit-btn" icon="el-icon-s-promotion" type="plain">Submit</el-button>
						</template>
					</template>

					<template v-if="['radioSelect'].includes(property.type)">
						<el-radio-group 
								v-model="property.vModelValue"
								@change="handleClick(property)"
								class="radio-group-type"
								:fill="activeColor"
								>
								<el-radio  
										class="form-item-el-radio"
										v-for="(option, index) in property.dropdownOption"
										:key="option+index"
										:label="option">
										<span>{{ option }}</span>
										<VPadding :unit="0.4" v-if="property.dropdownOption.length!==0 && index < property.dropdownOption.length - 1"/>
								</el-radio>
						</el-radio-group>
					</template>
					
					<template v-if="['multiSelect', 'list'].includes(property.type)">
						<el-checkbox-group
								v-model="multiSelect"
								@change="setListMultiSelectValue"
								:value="getListMultiSelectPropertyValue"
								class="customer-journey-form__input"
								>
								<el-checkbox  
										v-for="(option ,index) in property.dropdownOption"
										:key="option+index"
										:label="option">
										<span>{{ option }}</span>
										<VPadding :unit="0.4" v-if="property.dropdownOption.length!==0 && index < property.dropdownOption.length - 1"/>
								</el-checkbox>
						</el-checkbox-group>
						<template v-if="showSubmit">
							<VPadding :unit="0.4"/>
						 	<el-button @click="handleClick(property)" class="form-item-multiselect-submit-btn" icon="el-icon-s-promotion" type="plain">Submit</el-button>
						</template>
					</template>

					<el-button
						@click="handleClick(property)"
						type="primary"
						v-if="property.name === 'feedback'"
						class="rp-feedback-submit"
					>
					<PaperPlane />
					</el-button>
				</div>
				<div class="rp-error-msg" v-if="isError || property.isError">{{getErrorMessage}}</div>
			</div>

			<div v-else>
				<div>
					<el-input
						:type="getFieldType"
						:id="`get-${property.name}`"
						size="small"
						v-model="property.vModelValue"
						@focus="handleFocus(property)"
						@keyup.enter.native.exact="submitOnEnter(property)"
					>
						<el-button
							@click="handleClick(property)"
							type="primary"
							icon="el-icon-arrow-right"
							slot="append"
							v-if="showSubmit"
							class="customer-journey-form__input-submit-btn"
						/>
					</el-input>
					<el-button
						@click="handleClick(property)"
						type="primary"
						v-if="property.name === 'feedback'"
						class="rp-feedback-submit"
					>
						<PaperPlane />
					</el-button>
				</div>
				<div class="rp-error-msg" v-if="isError || property.isError">{{getErrorMessage}}</div>
			</div>
		</div>
	</div>
</template>
<script>
import FileUpload from './FileUpload';
import PaperPlane from '@/components/Images/PaperPlane'
export default {
	name: "FormItem",
	components: {
		FileUpload,
		PaperPlane
	},
	props: {
		property: {
			type: Object,
			required: false
		},
		showSubmit: {
			type: Boolean,
			required: false,
			default: false
		},
		showAllDataTypes: {
			type: Boolean,
			default: false
		},
		popoverWidth: {
			type: Number,
			default: 340
		}
	},
	data() {
		return {
			EMAIL_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			PHONE_REGEX: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
			isError: false,
			showSelectMenu: false,
			fileList: [],
			multiSelect: [],
		};
	},

	methods: {
		closeSelectMenu() {
			this.showSelectMenu = false;
		},
		setBooleanValueChange(val) {
			this.property.vModelValue = val;
			this.handleClick(this.property);
		},
		setListMultiSelectValue(value) {
				if(Array.isArray(value)){
					this.property.vModelValue = value
					if(this.property.groupName === 'People Data') {
						this.property.vModelValue = JSON.stringify(value)
					}
				} else {
						this.property.vModelValue = [value]
						if(this.property.groupName === 'People Data') {
							this.property.vModelValue = JSON.stringify([value])
						}
				}
				// if(this.showSubmit){
				// 	this.handleClick(this.property)
				// }
				this.handleFocus(this.property)
		},
		openSelectMenu() {
			this.showSelectMenu = true;
		},
		handleGroupSelection(item, value) {
			this.handleFocus(this.property)
			console.log(item);
		},
		updateFileList(fileList) {
			this.property.vModelValue = fileList;
			this.property.isError = false;
			this.isError = false;
			this.$emit('handleError', false)
		},
		checkDataValidation(property) {
			if (property) {
				const { name, vModelValue, required } = property;
				if (name === "email") {
					if (this.EMAIL_REGEX.test(vModelValue)) {
						return true;
					} else {
							if(!required && !vModelValue){
									return true
							}
						return false;
					}
				} else if (name === "phone") {
					if (this.PHONE_REGEX.test(vModelValue)) {
						return true;
					} else {
						if(!required && !vModelValue){
									return true
							}
						return false;
					}
				} else {
					if(Array.isArray(vModelValue) && vModelValue.length === 0){
							this.isError = true;
							this.$set(property, 'isError', true);
							return false;
					}
					else if (!(vModelValue) && required) {
							this.isError = false;
							this.$set(property, 'isError', true);
							return false;
					}
					else {
							this.isError = false;
							this.$set(property, 'isError', false);
							return true;
					}
				}
			} else {
			}
			return true;
		},
		submitOnEnter(property) {
			if (this.showSubmit) this.handleClick(property);
			else {
				this.$emit("handleEnter", property);
			}
		},
		handleClick(property) {
			if(this.showSubmit) {
				this.$emit("handleClick", property);
			} else {
				this.isError = !this.checkDataValidation(property);
				this.$emit('handleError', this.isError)
			}
		},

		handleQualifySubmit(property) {
			if(this.property.isError || this.isError) {
				this.handleFocus(property);
			}
			 if(this.showSubmit) {
				this.handleClick(property);
			 }
		},

		handleFocus(property) {
			this.$emit('handleError', false);
			this.$set(property, 'isError', false);
			this.isError = false;
			this.$emit("focus", property);
		},

		getTranslatedDisplayName(translationPath, fallbackDisplayName) {
			try {
				let translationValue = this.$t(translationPath);
				if (translationValue === translationPath) {
					translationValue = fallbackDisplayName;
				}
				return translationValue;
			} catch (e) {
				console.error(e);
				return fallbackDisplayName;
			}
		}
	},
	computed: {
		getBooleanValueChange() {
			const { vModelValue } = this.property;
			if((typeof vModelValue === 'boolean' && vModelValue) || (vModelValue && vModelValue ==="Yes") ) {
				this.property.vModelValue = "Yes";
				return "Yes";
			} else {
				this.property.vModelValue = "No";
				return "No";
			}
		},
		activeColor() {
			try {
				return this.$root.configuration.style.activeColor;
			}catch(e){
				return '#296df6';
			}
		},
		getListMultiSelectPropertyValue() {
			const value = this.property.vModelValue;

			if(Array.isArray(value)) {
				this.multiSelect = value;
				return value;
			} else if(value && value.trim()) {
				try {
					this.multiSelect = JSON.parse(value);
					this.property.vModelValue = JSON.parse(value);
					return JSON.parse(value);
				} catch (error) {
					this.multiSelect = [value];
					this.property.vModelValue = [value];
					return [value];
				}
			}

			return []; 
	},
		getErrorMessage() {
			if (this.property.isError || this.isError) {
				if (this.property.vModelValue)
					return `Please provide valid ${this.getTranslatedDisplayName(
						"inputPropDisplayNames." + this.property.name,
						this.property.displayName
					).toLowerCase()}`;
				else
					return `Please provide ${this.getTranslatedDisplayName(
						"inputPropDisplayNames." + this.property.name,
						this.property.displayName
					).toLowerCase()}`;
			}
			return "";
		},
		getFieldType() {
			if (this.property.name === "feedback") {
				return "textarea";
			} else {
				return "text";
			}
		}
	},
	mounted() {
		if(this.property.type === 'file'){
			this.property.vModelValue = null;
		}
	}
};
</script>

<style lang="scss">

// Common styles for form item elements
.rp-messenger-form-item {
	margin-bottom: 24px;

	.rp-messenger-form-item__label {
		margin-bottom: 8px;
		font-size: 14px;
		font-weight: 400;
		@include for-size(desktop-up){
			font-size: 17px !important;
		}
	}

	.radio-group-type{
		display: flex!important;
		flex-direction: column;
	}

	.rp-error-msg {
		font-size: 11.5px;
		font-weight: 400;
		margin-top: 4px;
		/* padding: 0 15px; */
		// text-transform: capitalize;
		color: #fd5f75;
		font-style: italic;
	}
	.rp-feedback-submit {
		margin: 0 auto;
		display: block;
		margin-top: 20px;
	}
	.el-radio__label {
		@include for-size(desktop-up){
			font-size: 16.5px;
		}
	}
	.customer-journey-form__input {
		width: 100%;
		@include for-size(desktop-up){
			font-size: 16.5px;
		}
		.el-textarea__inner {
			color: #333;
		}
		.el-checkbox__label, .el-radio__label {
			@include for-size(desktop-up){
				font-size: 16.5px;
			}
		}
		.customer-journey-form__input-submit-btn {
			.el-icon-arrow-right{
				font-size: 16px;
			}
		}
	}
		

	// .rp-date-picker {
	// 	width: 100%;
	// }
	

	/* Box Stylings */

	input{
		box-shadow:  inset 0 1px 3px #ddd;
	}

	textarea {
		box-shadow:  inset 0 1px 3px #ddd;
		border-color: #b3b3b3 !important;
		padding: 10px 15px;
	}

	.el-input {
		&.is-focus {
			.el-input__inner {
				border-color: #b3b3b3 !important;

				&:focus,
				&:hover {
					border-color: #b3b3b3 !important;
				}
			}
		}
		.el-input__inner {
			border-color: #b3b3b3;
			color: #333;
			padding: 10px 15px;

			&:focus,
			&:hover {
				border-color: #b3b3b3 !important;
			}
			@include for-size(desktop-up){
				font-size: 16.5px;
				height: 50px;
				line-height: 50px;
			}
		}
		.el-input__icon {
			color: #000;
			font-weight: 700;
		}
	}

	.el-select {
		input {
			box-shadow: none;
			background-color: #fbfbfb;
			background-image: linear-gradient(360deg, #e9e9e9 0%, #fff 80%);
			&::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
				color: #333;
				opacity: 1; /* Firefox */
			}

			&:-ms-input-placeholder { /* Internet Explorer 10-11 */
				color: #333;
			}

			&::-ms-input-placeholder { /* Microsoft Edge */
				color: #333;
			}
		}
		.el-input {
			&.is-focus {
				.el-input__inner {
					border-color: #b3b3b3 !important;

					&:focus,
					&:hover {
						border-color: #b3b3b3 !important;
					}
				}
			}
			.el-input__inner {
				border-color: #b3b3b3;
				color: #333;

				&:focus,
				&:hover {
					border-color: #b3b3b3 !important;
				}
			}
			.el-input__icon {
				color: #000;
				font-weight: 700;
			}
		}
	}

		/* Stylings for error messages */
	.customer-journey-form__input {

		&.error {
			input {
				border: 2px solid #ff0000 !important;
				&:focus,
				&:hover {
					border-color: #ff0000 !important;
				}
			}
			textarea {
				border: 2px solid #ff0000 !important;

				&:focus,
				&:hover {
					border-color: #ff0000 !important;
				}
			}
		}

		.el-radio {
			margin-left: 2px;
		}
	}
	.el-select {
			&.error {
				input {
					border-color: #ff0000 !important;
					border: 2px solid #ff0000 !important;
				}

				&:focus,
				&:hover {
					input {
						border-color: #ff0000 !important;
					}
				}
				.el-select__input {
					border: none;
				}
				.el-input {
					&.is-focus {
						.el-input__inner {
							border-color: #ff0000 !important;

							&:focus,
							&:hover {
								border-color: #ff0000 !important;
							}
						}
					}
					.el-input__inner {
						border-color: #ff0000;
						&:focus,
						&:hover {
							border-color: #ff0000 !important;
						}
					}
				}	
		}
	}

	/* Input Items Stylings */
	.el-checkbox-group {
		display: flex;
		flex-direction: column;
		
		.el-checkbox {
			text-align: left;
			display: flex;
			white-space: normal;
		}
		.el-checkbox__input {

			&.is-checked {
				.el-checkbox__inner {
					background-color: #fff;
					border-color: #cdcdcd;

					&::after {
						border-color: #4d4d4d;
					}

					&:focus,
					&:hover {
						border-color: #cdcdcd !important;
					}
				}
				+.el-checkbox__label {
					color: inherit;
				}
			}
		}
		.el-checkbox__inner {
			width: 18px;
			height: 18px;

			&::after {
				height: 9px;
				width: 5px;
				top: 1px;
				left: 5px;
				border-width: 2px;
			}

			&:focus,
			&:hover {
				border-color: #cdcdcd !important;
			}
		}
	}

	.el-upload {
		width: 100%;
		.el-upload-dragger {
			width: 100%;
			max-height: 87px;
		}
	}

	.el-radio {
		white-space: normal !important;
		line-height: 22px !important;
		text-align: left;
		display: flex;

		.el-radio__label {
			word-break: break-word;
			cursor: auto;
		}

		.el-radio__input {
			margin-top: 4px;
			@include for-size(desktop-up){
				margin-top: 2px;
			}

			&.is-checked {
				.el-radio__inner {
					background-color: #fff;
					border-color: var(--theme-color);
				}
				+.el-radio__label {
					color: inherit;
				}
			}
			.el-radio__inner {
				width: 18px;
				height: 18px;
				&::after {
						border: 2px solid #fff;
						background-color: var(--theme-color);
						width: 14px;
						height: 14px;
				}
			}
		}
	}

	.el-date-editor {
		width: 100% !important;
		.el-input__inner {
			padding-left: 15px;
		}

		.el-input__prefix {
			left: auto;
			right: 5px;
		}

		.el-icon-date {
			color: #353535;
			font-size: 20px;
		}
	}

}

/* Stylings for el-select dropdown popover */

.el-select-dropdown {
	&.customer-journey-form__select-input {
		margin-top: 1px !important;
		margin-bottom: 1px !important;
		border: 1px solid #b3b3b3;
		box-shadow: inset 0 1px 3px #ddd;
		border-radius: 4px;
		max-width: 340px;
		position: absolute !important;
		top: 40px !important;
		left: 0px !important;
	}
	.popper__arrow {
		display: none !important;
		&::after {
			display: none !important;
		}
	}
	ul.el-select-dropdown__list {
		border-color: #b3b3b3;
		padding: 0px;
		max-height: 150px;
		overflow-y: auto;

		li {
			border-bottom: 1px solid #d7d7d7;
			padding-top: 6px;
			padding-bottom: 6px;
			height: 48px;
		}
		.el-select-dropdown__item {
			color: #000;
			background-color: inherit;
			font-weight: 400;

			&.selected {
				color: #000;
				background-color: inherit;
				font-weight: 500;
			}

			&:hover {
				background-color: inherit;
			}

		}

		.customer-journey-form__select-input-item {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			align-content: center;
			background-color: inherit;

			.customer-journey-form__select-input-item-name {
				max-width: 90%;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}
			.customer-journey-form__select-input-item-icon {
				font-weight: 500 !important;
				font-size: 20px;
			}
		}
		.el-select-dropdown__item{
			&.hover {
				background-color: inherit;
			}
		}
	}
}

// Styles for date picker popover
.rp-messenger-form-item__date-picker {
	// width: 340px !important;

	.el-picker-panel__content {
		.el-date-table {
			td.current {
				span {
					background-color: var(--theme-color);
				}
			}
			td.today {
				span {
					color: var(--theme-color);
				}
			}
		}
	}
}
</style>
